import { css } from '@emotion/react';
import {
  forwardRef, type PropsWithChildren,
} from 'react';
import type { Theme } from '~/_shared/themes/theme.model';

const panelStyle = (theme: Theme) => css({
  backgroundColor: theme.accordionColors.itemBackground,
  padding: '14px',
});

export const AccordionPanel = forwardRef<HTMLDivElement, PropsWithChildren & React.DetailedHTMLProps<React.DetailsHTMLAttributes<HTMLDivElement>, HTMLDivElement>>(
  ({ children, ...props }, ref) => {
    return (
      <div
        {...props}
        ref={ref}
        data-element="accordion-item-panel"
        css={panelStyle}
      >
        {children}
      </div>
    );
  });

AccordionPanel.displayName = 'AccordionPanel';
